if(window.location.href.includes('?type=using-tips')){
    $('.uT_video').show()
    $('.product_content').hide()
}

var wFlag=true
if(window.innerWidth<750){
    wFlag=false
}

function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

function autoPlayOnView(className, threshold = 0.5) {
    const elements = $(className).get();
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play();
          observer.unobserve(entry.target); // 播放一次后取消观察
        }
      });
    }, { threshold });
  
    elements.forEach(el => observer.observe(el));
}

$(()=>{
    //box1
    ScrollTrigger.create({
        trigger:'.box1',
        start:wFlag?'top center-=20%':'top center',
        end:'+=0%',
        //scrub:true,
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box1_text div:first-child',{scale:7,opacity:0})
            .from('.box1_text div:last-child',{y:'2rem',opacity:0})
    })

    //box3
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3Swiper',
            start:'top bottom-=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            //scrub:1,
            animation:gsap.timeline()
                .to('.box3Swiper .swiper-wrapper .swiper-slide',{x:0,opacity:1,stagger:0.2})
        })
    
        ScrollTrigger.create({
            trigger:'.box3_border',
            start:'top top+=15%',
            end:'+=80%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box3_video',{opacity:1})
                .to('.box3_video',{width:'100%',height:'100%',y:'-50%',borderRadius:0})
                .to('.box3_video video',{width:'100%'},'-=50%')
                .from('.box3_video a',{opacity:0},'-=50%')
        })
    
        ScrollTrigger.create({
            trigger:'.box3_border',
            start:'top top+=15%',
            end:'+=100%',
            pin:true,
        })
    }else{
        var box3Swiper = new Swiper('.box3Swiper', {
            slidesPerView: 1.25,
            centeredSlides: true,
            autoplay:true,
            pagination: {
                el: '.box3Swiper-pagination',
                clickable:true
            },
        })

        // 假设新顺序： [2, 0, 1]
        const newOrder = [2, 3, 1,0,4];
        const reordered = newOrder.map(i => box3Swiper.slides[i].outerHTML);

        box3Swiper.removeAllSlides();          // 清空所有
        box3Swiper.appendSlide(reordered);     // 按新顺序添加回来
    }

    showUp('.nc_title')

    //box4
    autoPlayOnView('.box4_video')
    $('.box4_video').on('ended', function() {
        $(this).css({opacity:0});
        box4Swiper.autoplay()
    });

    var box4Swiper = new Swiper('.box4Swiper', {
        slidesPerView: 1,
        autoplay:!wFlag,
        effect: 'fade',
        loop:true,
        on:{
            slideChange: function(){
                var index = this.realIndex
                $('.box4_icon div').eq(index).addClass('box4_active').siblings().removeClass('box4_active')
                $('.box4_text div').eq(index).addClass('display_show').siblings().removeClass('display_show')
            },
        }
    })
    $('.box4_icon div').click(function(){
        var index = $(this).index()+1
        box4Swiper.slideTo(index, 300, false)
    })

    //box2
    ScrollTrigger.create({
        trigger:'.box2',
        start:wFlag?'top top+=20%':'top center',
        end:'+=0%',
        //toggleActions:'play none none reverse',
        //scrub:1,
        animation:gsap.timeline()
            .to('.box2_bg',{scale:wFlag?0.6:0.8,y:wFlag?'8rem':'3rem',borderRadius:'2rem'})
            .from('.box2_text div',{y:'2rem',opacity:0},'-=20%')
    })

    //box6
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box6',
            start:'top+=220% center-=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .to('.box6_flag',{opacity:0})
                .to('.box6_text',{opacity:0},'<')
                .to('.box6_img',{x:'-25%'},'<')
                .from('.box6_mask',{x:'100%'},'<')
        })

        ScrollTrigger.create({
            trigger:'.box6',
            start:'top+=160% center-=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box6_title',{opacity:0,y:'2rem'})
                .from('.box6_text',{opacity:0,y:'2rem'},'<')
        })

        ScrollTrigger.create({
            trigger:'.box6',
            start:'top center-=20%',
            end:'+=150%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box6_move',{x:'300%'})
                .to('.box6_move img:nth-child(2)',{rotate:'1440deg'},'<')
                .to('.box6_move img:nth-child(3)',{rotate:'1440deg'},'<')
                .to('.box6_img',{clipPath: 'inset(40% -20% 43% 0%)'},'-=85%')
                .to('.box6_img',{clipPath:'inset(0% 0% 0% 0%)',duration:0.1})
        })

        ScrollTrigger.create({
            trigger:'.box6',
            start:'top top+=4%',
            end:'+=220%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box6',
            start:'top+=200% center-=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .to('.box6_flag',{opacity:0.2})
                .to('.box6_img',{opacity:0.2},'<')
                .from('.box6_mask',{y:'2rem',opacity:0},'<')
        })

        ScrollTrigger.create({
            trigger:'.box6',
            start:'top+=140% center-=20%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box6_title',{opacity:0,y:'2rem'})
                .from('.box6_text',{opacity:0,y:'2rem'},'<')
        })

        ScrollTrigger.create({
            trigger:'.box6',
            start:'top center-=20%',
            end:'+=120%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box6_Mmove',{y:'172%'})
                .to('.box6_img',{clipPath: 'inset(0% 32% -20% 31%)'},'-=85%')
                .to('.box6_img',{clipPath:'inset(0% 0% 0% 0%)',duration:0.1})
        })

        ScrollTrigger.create({
            trigger:'.box6',
            start:'top top+=6%',
            end:'+=180%',
            pin:true,
        })
    }

    //box5
    showUp('.box5_title')
    ScrollTrigger.create({
        trigger:'.box5',
        start:'top+=20% top+=4%',
        end:'+=50%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            //.from('.box5_item div',{opacity:0,duration:0.1})
            .from('.box5_item div',{y:'2rem',opacity:0})
            .to('.box5_item img',{y:wFlag?'-4rem':'-2.5rem',scale:0.9},'<')
    })

    ScrollTrigger.create({
        trigger:'.box5',
        start:'top top+=4%',
        end:'+=50%',
        pin:true,
    })

    //box7
    autoPlayOnView('.box7 video')
    ScrollTrigger.create({
        trigger:'.box7_title',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box7_title',{y:'2rem',opacity:0,ease:'none',duration:0.5})
            .from('.box7_title div',{scale:wFlag?10:6,opacity:0,ease:'none',duration:0.3},'-=50%')
    })

    //box8
    autoPlayOnView('.box8 video')
    ScrollTrigger.create({
        trigger:'.box8_title',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box8_title c',{y:'2rem',opacity:0,ease:'none',duration:0.5})
            .from('.box8_title p',{scale:wFlag?10:6,opacity:0,ease:'none',duration:0.3},'-=50%')
    })

    //box9
    showUp('.box9_title')
    $('.box9_btn div').click(function(){
        var index = $(this).index()
        $('.box9_left div').eq(index).addClass('display_show').siblings().removeClass('display_show')
        if(index==0){
            $('.box9_btn span').css({left:'1%'})
        }else if(index==1){
            $('.box9_btn span').css({left:'33%'})
        }else if(index==2){
            $('.box9_btn span').css({left:'66%'})
        }
    })

    //box10
    showUp('.box10_title')
    new Swiper('.box10Swiper', {
        slidesPerView:wFlag?5:1.5,
        centeredSlides:true,
        autoplay:true,
        pagination: {
            el: '.box10Swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.box10_btn img:nth-child(2)',
            prevEl: '.box10_btn img:nth-child(1)',
        },
        on:{
            slideChange: function(){
                $('.box10_item video').each(function(){
                    $(this).get(0).pause();
                })
                var video = $('.box10_item video').eq(this.realIndex).get(0);
                video.currentTime = 0; // 重置到开头
                video.play();
            },
        },
    })

    //box11
    if(wFlag){
        autoPlayOnView('#box11Video')
        ScrollTrigger.create({
            trigger:'.box11',
            start:'top+=20% top+=6%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box11_left',{width:'100%',borderRadius:0,scale:1.1})
                .from('.box11_right',{x:'100%',opacity:0},'-=90%')
        })

        ScrollTrigger.create({
            trigger:'.box11',
            start:'top top+=6%',
            end:'+=70%',
            pin:true,
        })
    }else{
        showUp('.box11_title')
        ScrollTrigger.create({
            trigger:'.box11',
            start:'top top+=15%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            //scrub:1,
            animation:gsap.timeline()
                .from('.box11_right',{opacity:0,y:'2rem'})
        })
    }

    //box12
    ScrollTrigger.create({
        trigger:'.box12',
        start:'top+=10% top+=6%',
        end:'+=30%',
        scrub:1,
        animation:gsap.timeline()
            .to('.box12_icon',{y:wFlag?'4.2rem':'5.8rem',scale:wFlag?0.05:0.15,duration:1},0)
            .from('.box12_img',{opacity:0,duration:0.8},0.2)
            .to('.box12_img img:last-child',{opacity:1,duration:0.05},0.95)
    })

    ScrollTrigger.create({
        trigger:'.box12',
        start:'top+=50% top+=6%',
        end:'+=40%',
        scrub:1,
        animation:gsap.timeline()
            .from('.box12_title',{opacity:0,y:'2rem'})
            .to('.box12',{backgroundImage:wFlag?'radial-gradient(circle, #214FEB 0%, #000 85%)':
                'radial-gradient(circle, #214FEB 0%, #000 135%)'},'<')
            .from('.box12_item div',{opacity:0,y:'2rem',stagger:0.2})
    })

    ScrollTrigger.create({
        trigger:'.box12',
        start:'top top+=6%',
        end:'+=100%',
        pin:true,
    })

    //box13
    ScrollTrigger.create({
        trigger:'.box13_title',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box13_title',{y:'2rem',opacity:0,ease:'none',duration:0.5})
            .from('.box13_title div',{scale:wFlag?10:6,opacity:0,ease:'none',duration:0.3},'-=50%')
    })
    if(wFlag){
        var $video = $('.box13 video');
        ScrollTrigger.create({
            trigger:'.box13',
            start:'top top+=24%',
            end:'+=100%',
            scrub:true,
            // markers:true,
            onUpdate: function (self) {
                //$video[0].duration
                $video[0].currentTime = self.progress * 4.64;
                if(self.progress > 0.8){
                    $('.box13_item div').css({opacity:1})
                }else{
                    $('.box13_item div').css({opacity:0})
                }
            }
        })
        ScrollTrigger.create({
            trigger:'.box13',
            start:'top top+=4%',
            end:'+=100%',
            pin:true,
        })
    }else{
        autoPlayOnView('.box13 video')
    }

    //box17
    showUp('.box17_title')
    showUp('.box17_item')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box17',
            start:'top top+=6%',
            end:'+=100%',
            scrub:1,
            pin:true,
            // markers:true,
            animation:gsap.timeline()
                .to('.box17_img2',{opacity:1,duration:0.4})
                .to({},{duration:0.2})
                .from('.box17_1',{opacity:0,duration:0.2})
                .to({},{duration:0.2})
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box17',
            start:'top top+=6%',
            end:'+=50%',
            scrub:1,
            pin:true,
            animation:gsap.timeline()
                .to('.box17_img2',{opacity:1})
                .to({},{duration:0.3})
        })
    }

    //box14
    ScrollTrigger.create({
        trigger:'.box14_title',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box14_title',{y:'2rem',opacity:0,ease:'none',duration:0.5})
            .from('.box14_title div',{scale:wFlag?10:6,opacity:0,ease:'none',duration:0.3},'-=50%')
    })
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box14Swiper',
            start:'top bottom-=20%',
            end:'+=30%',
            //toggleActions:'play none none reverse',
            scrub:1,
            animation:gsap.timeline()
                .from('.box14Swiper .swiper-wrapper .swiper-slide',{y:'2rem',opacity:0,stagger:0.2})
        })
    }else{
        new Swiper('.box14Swiper', {
            slidesPerView: 1.125,
            centeredSlides: true,
            autoplay:true,
            pagination: {
                el: '.box14Swiper-pagination',
                clickable:true
            },
        })
    }

    //box15
    showUp('.box15_title')
    new Swiper('.box15Swiper', {
        autoplay:true,
        pagination: {
            el: '.box15Swiper-pagination',
            clickable:true
        },
    })

    //box16
    showUp('.box16_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box16',
            start:'top top+=34%',
            end:'+=60%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box16_item div:nth-child(1)',{x:'-95%'})
                .from('.box16_item div:nth-child(2)',{x:'90%'},'<')
                .from('.box16_item div:nth-child(3)',{x:'-85%'},'<')
        })

        ScrollTrigger.create({
            trigger:'.box16',
            start:'top top+=4%',
            end:'+=50%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box16',
            start:'top top+=8%',
            end:'+=80%',
            scrub:1,
            pin:true,
            animation:gsap.timeline()
                .from('.box16_item div:nth-child(2)',{y:'2rem',opacity:0})
                .to('.box16_item div:nth-child(1)',{y:'-3rem',scale:0.85},'<')
                .to('.box16_item div:nth-child(1) p',{opacity:0},'<')
                .from('.box16_item div:nth-child(3)',{y:'2rem',opacity:0})
                .to('.box16_item div:nth-child(2)',{y:'-1.2rem',scale:0.95},'<')
                .to('.box16_item div:nth-child(2) p',{opacity:0},'<')
        })
    }

 
    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })
    
    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
        window.open('https://store.oxva.com/products/xlim-3-ultra'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })
})